import React from "react"
import { X } from "lucide-react"
import IconButton from "../Buttons/IconButton.js"

interface AppModalHeaderProps {
  title: React.ReactNode
  onClose?: () => void
  className?: string
  titleClassName?: string
  align?: "start" | "center"
  closeLabel?: string
  endAdornment?: React.ReactNode
  startAdornment?: React.ReactNode
}

const AppModalHeader: React.FC<AppModalHeaderProps> = ({
  title,
  onClose,
  className = "",
  titleClassName = "font-semibold text-my-black",
  align = "start",
  closeLabel = "Fechar modal",
  endAdornment,
  startAdornment,
}) => {
  const isCentered = align === "center"

  return (
    <div className={`flex items-center gap-3 border-b border-slate-100 p-4 ${isCentered ? "relative justify-center" : "justify-between"} ${className}`.trim()}>
      <div className={`flex min-w-0 items-center gap-2 ${isCentered ? "w-full justify-center px-10 text-center" : ""}`.trim()}>
        {startAdornment}
        <div className={titleClassName}>{title}</div>
      </div>
      <div className={`flex items-center gap-2 ${isCentered ? "absolute right-0 top-1/2 -translate-y-1/2" : ""}`.trim()}>
        {endAdornment}
        {onClose ? (
          <IconButton onClick={onClose} variant="subtle" ariaLabel={closeLabel}>
            <X size={18} />
          </IconButton>
        ) : null}
      </div>
    </div>
  )
}

export default AppModalHeader